<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getThemes()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Themes class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Themes</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Cover</th>
                                                <th>Name</th>
                                                <th>Code</th>
                                                <th>Status</th>
                                                <th>Total Use Of Theme</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in themes.data" :key="data.id" v-on:click="editThemes(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_themes" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <img class="mr-3 img-thum-product" :src="data.photo">
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.code}}</td>
                                                <td>
                                                    <label v-if="data.is_show === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Active</label>
                                                    <label v-if="data.is_show === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> Not Active</label>
                                                </td>
                                                <td>
                                                    <label class="badge badge-info">{{data.events_count}} Times</label>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="themes.total === 0" class="text-center no-data">Themes data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="themes"
                                                :sorting="sorting"
                                                @paginate="getThemes()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Themes Data Still Empty</h2>
                                    <p>On this page you can create Themes user</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Themes class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Themes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_themes.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_themes = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_themes.length}}</span> themes selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteThemes()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_themes="del_themes" @getThemes="getThemes(),del_themes = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../theme/ModalForm.vue'
    import moment from 'moment'


    export default {
        name: "Themes",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_themes:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getThemes().then(() => {
                if(this.themes.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('ThemesControl', {
                themes: state => state.themes,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.themes.data ? this.del_themes.length == this.themes.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.themes.data.forEach(function (themes) {
                            if(themes.id !== 1){
                                selected.push(themes.id);
                            }
                        });
                    }
                    this.del_themes = selected;
                }
            }
        },
        methods: {
            ...mapActions('ThemesControl', ['getThemes','deleteThemes']),
            ...mapMutations('ThemesControl', ['CLEAR_THEMES','ASSIGN_FORM']),
            
            editThemes:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Themes')
            },
            alertDeleteThemes:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this theme data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteThemes(this.del_themes).then(
                            this.$toast.success('Successfully Deleting Themes'),
                            this.del_themes = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_THEMES()
        }
    };

</script>
